var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIcYoutube = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 18,
    viewBox: "0 0 27 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.529 17.977C6.64856 17.8871 4.98165 17.8063 3.95707 17.5952C3.26388 17.4549 2.66149 17.1435 2.2198 16.6919C1.87843 16.35 1.60695 15.8285 1.39633 15.1048C1.21566 14.502 1.1453 14.0004 1.04498 12.7752C0.89141 10.01 0.854801 7.74924 1.04498 5.2232C1.20188 3.82825 1.27795 2.17228 2.32012 1.20618C2.8122 0.754032 3.38464 0.46306 4.02744 0.342773C5.03158 0.15212 9.30962 0.00140381 13.7384 0.00140381C18.1572 0.00140381 22.4447 0.15212 23.4498 0.342773C24.2528 0.493488 25.0059 0.94516 25.4481 1.52758C26.399 3.02332 26.4156 4.88326 26.5121 6.33812C26.5521 7.03132 26.5521 10.9675 26.5121 11.6607C26.3619 13.96 26.2411 14.7734 25.8998 15.6169C25.6887 16.1494 25.5085 16.4304 25.1966 16.7418C24.7074 17.221 24.0838 17.5398 23.4089 17.6556C19.1855 17.9732 15.5993 18.0421 11.529 17.977ZM17.9965 8.73816C15.6468 7.48251 13.397 6.31815 11.0973 5.1129V12.3235C13.5173 11.0079 16.0685 9.80268 18.0064 8.72818L17.9965 8.73816Z",
    fill: "#CD201F"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcYoutube, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-youtube.33e125b7.svg";
export { ForwardRef as ReactComponent };